import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import { itemContainer } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { CellPhone, Phone, PhoneInputViewModel } from "src/common/utilities/phoneInput/phoneInput-viewModel";
import { CreateCustomerCreationRequestViewModel } from "src/Crm/createCustomerCreationRequest/createCustomerCreationRequest-viewModel";
import { SearchCustomerViewModel, customerForSelector } from "src/Crm/searchCustomer/searchCustomer-viewModel";
import { HuntedProduct, HuntMediatorManipulationViewModel, RequestInvoiceCreationSessionIdMessage } from "src/Sell/huntMediatorManipulation/huntMediatorManipulation-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { productForSelector, ProductSearchableSelectorViewModel, ShowAdvancedSearchPopupMessage } from "src/Warehouse/productSearch/productSearchableSelector/productSearchableSelector-viewModel";
import { InvoiceLineItem } from "../invoiceDetail/invoiceDetail-viewModel";
import  { InvoiceManipulationView } from "./invoiceManipulation-view"
import { Converters } from "src/uicomponents/converters";

export class InvoiceManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'ثبت فاکتور فروش';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.products = ObservableArray.create<Product>();
        this.productSelector = new ProductSearchableSelectorViewModel(this,false, true, true);
        this.productSelector.onSelectionChanged = q=>{
            this.huntProduct(q.measuredProducts[0].id, this.productSelector.items, this.productSelector.carBrandId, this.productSelector.carModelId);
        }
        this.customerSelector = new SearchCustomerViewModel(this);
        this.customerSelector.onSelectionChanged = q=>{
            this.checkCustomer(q)            
        }
        this.refresh();
    }
    async checkCustomer(q:customerForSelector){
        let lastSaleTime;
        try {
            this.isLoading = true;
            let lastSaleTimeResult = await ServerConnection.callServer('/Complex/SellServices/GetCustomerLastSaleTime',{
                CustomerId : q.id
            });
            lastSaleTime = lastSaleTimeResult.Time;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
        if(q.isBlackList==true || q.monopolyValid==false){
            let strings = [];
            if(q.isBlackList==true){
                strings.push('مشتری در لیست سیاه قرار دارد.');
            }
            if(q.monopolyValid==false){

                let lastSaleTimeString =lastSaleTime==null ? "" :`تاریخ آخرین خرید : ${new Converters().CustomPersianDateConverter(lastSaleTime,"YYYY/MM/DD")}`;
                if(stringIsNullOrEmpty(lastSaleTime)){
                    strings.push('مشتری در انحصار شعبه دیگری قرار دارد.');
                }else{
                    strings.push(`مشتری در انحصار شعبه دیگری قرار دارد.\r\n${lastSaleTimeString}`);
                }
            }
            let finalMessage = strings.join('\n');
            this.messageBoxConfirmWarning(finalMessage,'خطا در انتخاب مشتری');
            return;
        }

        this.selectedcustomerId = q.id;
        this.code = q.code;
        this.name = q.name;
        this.selectedcustomerTitle = q.title;
        this.nationalCode = q.nationalCode;
        this.phones = q.phones;
        this.cellphones = q.cellphones;
        this.phoneInput = q.phoneInput;
        this.monopolyDistrictNames = q.monopolyDistrictNames;
        this.lastSaleTime = lastSaleTime;
        this.firstPhone = q.cellphones.length>0 ? q.cellphones[0].getAsString()
            : q.phones.length>0 ? q.phones[0].getAsString() : '';
    }
    async loadForEdit(invoiceId: string, customerId : string, oldItems: ObservableArray<InvoiceLineItem>, districtId: string) {
        this.oldInvoiceId = invoiceId;
        this.customerSelector.selectById(customerId);
        oldItems.forEach(item => {
            let r = new Product(this);
            r.rowNumber = this.products.length + 1;
            r.id = item.id;
            r.productCarModel = item.productCarModel;
            r.productCode = item.productCode;
            r.productName = item.productName;
            r.currentFee = item.feePrice;
            r.count = item.amount;
            r.deficit = item.deficit;
            r.districtId = districtId;
            // r.districtName = item.districtName;
            r.warehouseId = item.saleFromWarehouseId;
            r.warehouseName = item.saleFromWarehouseName;
            if(this.products.findIndex(o => o.id === r.id && o.warehouseId === r.warehouseId) === -1){
                this.products.push(r);
                this.requestCalculatePrice();
            };
        });
        this.isEdit = true;
        this.getWarehouseBalanceInfo();
    }
    async getWarehouseBalanceInfo() {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetWarehouseBalanceByProductIds', {
            MeasuredProductIds: this.products.map(q => {
                return {
                    MeasuredProductId: q.id,
                    WarehouseId: q.warehouseId
                }
            }),
        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
        result.WarehouseBalances.map(p => {
            let f = this.products.find(x => x.id == p.MeasuredProductId &&  x.warehouseId == p.WarehouseId);
            f.alreadyLockedAmount = f.count;
            f.maxBalance = p.AccessibleBalance + f.count;
        });
    }

    GetDefaultView(): View <ViewModel> {
        return new InvoiceManipulationView();
    }
    public getTypeId(): string {
        return "VM-831FF3EC-BE2E-47E1-B40D-4AB657AAC720"
    }
    
    public set products(v: ObservableArray<Product>) { this._products = v; } public get products(): ObservableArray<Product> { return this._products;} private _products: ObservableArray<Product>;
    public set oldInvoiceId(v: string) { this._oldInvoiceId = v; } public get oldInvoiceId(): string { return this._oldInvoiceId;} private _oldInvoiceId: string;
    public set isEdit(v: boolean) { this._isEdit = v; } public get isEdit(): boolean { return this._isEdit;} private _isEdit: boolean;
    public set selectedcustomerId(v: string) { this._selectedcustomerId = v; } public get selectedcustomerId(): string { return this._selectedcustomerId;} private _selectedcustomerId: string;
    public set selectedcustomerTitle(v: string) { this._selectedcustomerTitle = v; } public get selectedcustomerTitle(): string { return this._selectedcustomerTitle;} private _selectedcustomerTitle: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode;} private _nationalCode: string;
    public set phones(v: ObservableArray<Phone>) { this._phones = v; } public get phones(): ObservableArray<Phone> { return this._phones;} private _phones: ObservableArray<Phone>;
    public set cellphones(v: ObservableArray<CellPhone>) { this._cellphones = v; } public get cellphones(): ObservableArray<CellPhone> { return this._cellphones;} private _cellphones: ObservableArray<CellPhone>;
    public set phoneInput(v: PhoneInputViewModel) { this._phoneInput = v; } public get phoneInput(): PhoneInputViewModel { return this._phoneInput;} private _phoneInput: PhoneInputViewModel;
    public set selectedProduct(v: Product) { this._selectedProduct = v; } public get selectedProduct(): Product { return this._selectedProduct;} private _selectedProduct: Product;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set customerSelector(v: SearchCustomerViewModel) { this._customerSelector = v; } public get customerSelector(): SearchCustomerViewModel { return this._customerSelector;} private _customerSelector: SearchCustomerViewModel;
    public set productSelector(v: ProductSearchableSelectorViewModel) { this._productSelector = v; } public get productSelector(): ProductSearchableSelectorViewModel { return this._productSelector;} private _productSelector: ProductSearchableSelectorViewModel;
    public set firstPhone(v: string) { this._firstPhone = v; } public get firstPhone(): string { return this._firstPhone;} private _firstPhone: string;
    public set currencyId(v: string) { this._currencyId = v; } public get currencyId(): string { return this._currencyId;} private _currencyId: string;
    public set currencyName(v: string) { this._currencyName = v; } public get currencyName(): string { return this._currencyName;} private _currencyName: string;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice;} private _totalPrice: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set totalDeficits(v: number) { this._totalDeficits = v; } public get totalDeficits(): number { return this._totalDeficits;} private _totalDeficits: number;
    public set totalAdditions(v: number) { this._totalAdditions = v; } public get totalAdditions(): number { return this._totalAdditions;} private _totalAdditions: number;
    public set additionCost(v: number) { this._additionCost = v; } public get additionCost(): number { return this._additionCost;} private _additionCost: number;
    public set monopolyDistrictNames(v: string) { this._monopolyDistrictNames = v; } public get monopolyDistrictNames(): string { return this._monopolyDistrictNames;} private _monopolyDistrictNames: string;
    public set lastSaleTime(v: moment.Moment) { this._lastSaleTime = v; } public get lastSaleTime(): moment.Moment { return this._lastSaleTime;} private _lastSaleTime: moment.Moment;
    public set discountRate(v: number) { 
        if(this._discountRate != getAsNumber(v,true)){
            this._discountRate = getAsNumber(v,true); 
            
            this.products.forEach(q => {
                let eachDiscount = Math.floor((this._discountRate * q.totalPrice / 100));
                q.deficit = eachDiscount;
            });
        }
    } public get discountRate(): number { return this._discountRate;} private _discountRate: number;
    
    
    private _sessionId:string;

    async refresh(){
        try {
            this.products.clear();
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SellServices/GetNewSessionId',{});
            this._sessionId = result.SessionId;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    public handleMessage(message: ViewModelMessage) {
        if(message instanceof RequestInvoiceCreationSessionIdMessage){
            return this._sessionId;
        }else if(message instanceof ShowAdvancedSearchPopupMessage){
            let result = this.showPopup(message.advancedSearch, false);
            return null;
        }else{
            return super.handleMessage(message);
        }
    }
    async requestCreation() {
        let inserter = new CreateCustomerCreationRequestViewModel(this);
        let resultCode = await this.showPopup(inserter);
    }

    async save(){
        try {
            this.isLoading = true;
            if (stringIsNullOrEmpty(this.oldInvoiceId)) {
                let result = await ServerConnection.callServer('Complex/SellServices/CreateInvoice', {
                    CustomerId: this.selectedcustomerId,
                    LineItems: this.products.map(q => {
                        return {
                            MeasuredProductId: q.id,
                            Amount: q.count,
                            FeePrice: q.currentFee,
                            DeficitPrice: q.deficit,
                            WarehouseId: q.warehouseId
                        }
                    })
                });
                if (result.IsSuccessful == true) {
                    if (result.InvoiceNumber.search(',') > 0) {
                        await this.messageBoxConfirmSuccess(`فاکتورهایی با شماره ${result.InvoiceNumber} با موفقیت ثبت شد.`, 'عملیات موفق');
                    } else {
                        await this.messageBoxConfirmSuccess(`فاکتور با شماره ${result.InvoiceNumber} با موفقیت ثبت شد.`, 'عملیات موفق');
                    }
                    this.close();
                } else if (result.Faults[0].Parameters.FaultId === "678D5F2E-E01D-4044-9184-C34D7696F796") {
                    throw "عدم امکان محاسبه قیمت";
                } else if (result.Faults[0].Parameters.FaultId === "8877E0B0-9DA1-4AA1-8348-062AB50EF737") {
                    throw "شما به دیگر شعب بدهی دارید. پیش از ثبت فاکتور لطفا بدهی های خود را تسویه کنید.";
                } else if (result.Faults[0].Parameters.FaultId === "9CE06C64-FCC0-4F92-BF96-B8C3A37461AF") {
                    throw "دسترسی به این کالاها وجود ندارد.";
                } else {
                    throw "عدم امکان ثبت فاکتور";
                }
            } else {
                let result = await ServerConnection.callServer('Complex/SellServices/EditInvoice', {
                    CustomerId: this.selectedcustomerId,
                    InvoiceId: this.oldInvoiceId,
                    LineItems: this.products.map(q => {
                        return {
                            MeasuredProductId: q.id,
                            Amount: q.count,
                            FeePrice: q.currentFee,
                            DeficitPrice: q.deficit,
                            WarehouseId: q.warehouseId
                        }
                    })
                });
                if (result.IsSuccessful == true) {
                    if (result.InvoiceNumber.search(',') > 0) {
                        await this.messageBoxConfirmSuccess(`فاکتورهایی با شماره ${result.InvoiceNumber} با موفقیت ویرایش و ثبت شد.`, 'عملیات موفق');
                    } else {
                        await this.messageBoxConfirmSuccess(`فاکتور با شماره ${result.InvoiceNumber} با موفقیت ویرایش شد.`, 'عملیات موفق');
                    }
                    this.close();
                } else if (result.Faults[0].Parameters.FaultId === "678D5F2E-E01D-4044-9184-C34D7696F796") {
                    throw "عدم امکان محاسبه قیمت";
                } else if (result.Faults[0].Parameters.FaultId === "17042F5E-8B3A-4412-A735-1277D40B48F3") {
                    throw "امکان ویرایش این فاکتور دیگر وجود ندارد.";
                } else {
                    throw "عدم امکان ثبت فاکتور";
                }
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
        }
    }
    
    async huntProduct(selectedProductId: string, otherResult:ObservableArray<itemContainer<productForSelector>>, carBrandId: string, carModelId: string) {
        let hunt = new HuntMediatorManipulationViewModel(this);
        hunt.loadById(selectedProductId, this.selectedcustomerId, otherResult, carBrandId, carModelId);
        let result = await this.showPopup(hunt);
        this.productSelector.carModelId = result.carModelId;
        this.productSelector.carBrandId = result.carBrandId;
        this.productSelector.isAdvancedSearch = result.isAdvancedSearch;
        if(result!=null && result instanceof HuntedProduct){
            let r = new Product(this);
            r.rowNumber = this.products.length + 1;
            r.id = result.measuredProductId;
            r.productCode = result.productCode;
            r.productName = result.productName;
            r.productCarModel = result.productCarModel;
            r.currentFee = result.price;
            r.maxBalance = result.balance;
            r.count = 1;
            r.districtId = result.districtId;
            r.districtName = result.districtName;
            r.warehouseId = result.warehouseId;
            r.warehouseName = result.warehouesName;
            r.isSelected = false;
            if(this.products.findIndex(o => o.id === r.id && o.warehouseId === r.warehouseId) === -1){
                this.products.push(r);
                this.requestCalculatePrice();
            };
        }
    }

    remove (removedProduct: Product) {
        let index = this.products.findIndex(o => o.id === removedProduct.id);
        this.products.splice(index,1);
        for (let i = index; i < this.products.length; i++) {
            let element = this.products[i];
            element.rowNumber--;
        }
        this.requestCalculatePrice();
    }
    
    private _calculatePriceTimer : any;
    async requestCalculatePrice() {
        if(this._calculatePriceTimer!=null){
            clearTimeout(this._calculatePriceTimer);
        }
        // this._calculatePriceTimer = setTimeout(() => {
        //     this.calculatePrice();
        // }, 500);
        this._calculatePriceTimer = setTimeout(() => {
            this.calculatePrice();
        }, 500);
    }

    async calculatePrice(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/SellServices/CalculatePrice', {
                Products: this.products.map(q => {
                    return {
                        MeasuredProductId: q.id,
                        Amount: q.count,
                        FeePrice: q.currentFee,
                        DeficitPrice: q.deficit,
                        WarehouseId: q.warehouseId
                    }
                })
            });
            if (result.IsSuccessful == false) {
                if (result.Faults[0].Parameters.FaultId === "678D5F2E-E01D-4044-9184-C34D7696F796") {
                    throw "عدم امکان محاسبه قیمت";
                } else {
                    throw "خطا";
                }
            }
            this.currencyId = result.CurrencyId;
            this.currencyName = result.CurrencyName;
            this.totalPrice = result.TotalPrice;
            this.finalPrice = result.FinalPrice;
            this.totalDeficits = result.TotalDeficits;
            this.totalAdditions = result.TotalAdditions;
            this.additionCost = result.AdditionCost;
            result.ProductPrices.forEach(serverProduct => {
                let relatedItem = this.products.find(x=>x.id==serverProduct.MeasuredProductId && x.warehouseId === serverProduct.WarehouseId);
                relatedItem.unitName = serverProduct.UnitName;
                relatedItem.finalPrice = serverProduct.FinalPrice;
                relatedItem.totalPrice = serverProduct.TotalPrice;
                relatedItem.deficit = serverProduct.DeficitAmount;
                relatedItem.currentFee = serverProduct.Fee;
                if(relatedItem.count>serverProduct.Balance+relatedItem.alreadyLockedAmount){
                    relatedItem.count = serverProduct.Balance+relatedItem.alreadyLockedAmount;
                }
            });
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex, 'خطا در محاسبه قیمت');

        } finally {
            this.isLoading = false;
        }
    }

    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.selectedcustomerId)){
            result.push('مشتری انتخاب نشده است.')
        }
        if(this.products.length < 1){
            result.push(' کالایی اضافه نشده است.')
        }
        if(this.products.filter(x=>x.currentFee <= 0 || x.count <= 0 || x.deficit < 0).length > 0){
            result.push('قیمت و یا میزان منفی برای کالا امکان پذیر نیست');
        }
        return result;
    }

    async confirm() {
        let verificationResult = this.verify();
        if(verificationResult.length>0){
            let errorMessage = verificationResult.join('\n');
            await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت فاکتور');
            return;
        }
        let inserter =new Confirmation(this);
        let resultCode = await this.showPopup(inserter);
        if(resultCode=='done'){
        }
    }
}

export class Product extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InvoiceManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.deficit =0;
        this.alreadyLockedAmount = 0;
    }
    private _typedParent : InvoiceManipulationViewModel;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    public set currentFee(v: number) { this._currentFee = v; } public get currentFee(): number { return this._currentFee;} private _currentFee: number;
    public set count(v: number) { 
        if(this._count != getAsNumber(v,true)){
            this._count = getAsNumber(v,true); 
            this.requestRecalculation();
        }
    } public get count(): number { return this._count;} private _count: number;
    public set deficit(v: number) { 
        if(this._deficit != getAsNumber(v,true)){
            this._deficit = getAsNumber(v,true); 
            this.requestRecalculation();    
        }
    } public get deficit(): number { return this._deficit;} private _deficit: number;
    public set alreadyLockedAmount(v: number) { this._alreadyLockedAmount = v; } public get alreadyLockedAmount(): number { return this._alreadyLockedAmount;} private _alreadyLockedAmount: number;
    
    public set maxBalance(v: number) { this._maxBalance = v; } public get maxBalance(): number { return this._maxBalance;} private _maxBalance: number;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice;} private _totalPrice: number;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;

    remove() {
        this._typedParent.remove(this);
    }

    private requestRecalculation(){
        this._typedParent.requestCalculatePrice();
    }
}

export class Customer extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InvoiceManipulationViewModel) {
        super(parent);
        this.typedParent = parent;
    }

    private typedParent: InvoiceManipulationViewModel;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode;} private _nationalCode: string;
    public set phones(v: ObservableArray<Phone>) { this._phones = v; } public get phones(): ObservableArray<Phone> { return this._phones;} private _phones: ObservableArray<Phone>;
    public set cellphones(v: ObservableArray<CellPhone>) { this._cellphones = v; } public get cellphones(): ObservableArray<CellPhone> { return this._cellphones;} private _cellphones: ObservableArray<CellPhone>;
    public set phoneInput(v: PhoneInputViewModel) { this._phoneInput = v; } public get phoneInput(): PhoneInputViewModel { return this._phoneInput;} private _phoneInput: PhoneInputViewModel;
    // public set choosed(v: boolean) { this._choosed = v; } public get choosed(): boolean { return this._choosed;} private _choosed: boolean;
    
}

export class Confirmation extends ViewModel implements IPopup{
    public getTypeId(): string {return 'confirmation';}
    public GetDefaultView(): View<InvoiceManipulationViewModel> {return null;}
    constructor(parent:InvoiceManipulationViewModel) {
        super(parent);
        this.allInfo = parent;
    }
    
    closePopup() {

    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    private  _isSaving:boolean;
    async save(){
        if(this._isSaving===true)
            return;
        this._isSaving = true;
        try {
            this.isLoading = true;
            await this.allInfo.save();
        } catch (ex) {
            console.log(ex);
        } finally {
            this._isSaving = false;
            this.isLoading = false;
        }
    }
    public set allInfo(v: InvoiceManipulationViewModel) { this._allInfo = v; } public get allInfo(): InvoiceManipulationViewModel { return this._allInfo;} private _allInfo: InvoiceManipulationViewModel;
    
}